import { render, staticRenderFns } from "./Places_Comp.vue?vue&type=template&id=6d55fc18&scoped=true&"
import script from "./Places_Comp.vue?vue&type=script&lang=js&"
export * from "./Places_Comp.vue?vue&type=script&lang=js&"
import style0 from "./Places_Comp.vue?vue&type=style&index=0&id=6d55fc18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d55fc18",
  null
  
)

export default component.exports